"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_SUGGESTIONS_API_MESSAGES = exports.BRAND_SUGGESTIONS_API_ERRORS = exports.BRAND_SUGGESTION_LIST_MAX = exports.BRAND_SUGGESTION_BASIS_TEXT = exports.BRAND_SUGGESTION_BASES = void 0;
/** What a suggestion is drawn from, in the spec's order of preference (spec:118-121). */
exports.BRAND_SUGGESTION_BASES = ['entered', 'sources', 'nameAndWebsite'];
/** The note in the "AI suggested" box that names the basis (spec:123, verbatim). */
exports.BRAND_SUGGESTION_BASIS_TEXT = {
    entered: "Based on what you've entered so far",
    sources: 'Based on your brand document and web pages',
    nameAndWebsite: "Based on your brand's name and website",
};
/** A suggested tag list or guideline list is short (spec:123): at most this many items. */
exports.BRAND_SUGGESTION_LIST_MAX = 5;
/**
 * What the suggestions route answers when it refuses. The code rides in `error`, the message in `message`,
 * which the web shows as it is. Access refusals use the brand API's BRAND_NO_ACCESS and BRAND_ADMIN_ONLY,
 * and the route answers BRAND_WORKSPACE_V2_OFF while the flag is off.
 */
exports.BRAND_SUGGESTIONS_API_ERRORS = {
    /** 429: this workspace asked for too many suggestions in the last hour. */
    RATE_LIMITED: 'BRAND_SUGGESTIONS_RATE_LIMITED',
    /** 503, before any model call: no AI endpoint on this install, so never placeholder text. */
    AI_UNAVAILABLE: 'BRAND_SUGGESTIONS_AI_UNAVAILABLE',
    /** 502: the AI call failed, or its answer could not be used. */
    AI_FAILED: 'BRAND_SUGGESTIONS_AI_FAILED',
};
exports.BRAND_SUGGESTIONS_API_MESSAGES = {
    RATE_LIMITED: "You've asked for a lot of suggestions in the last hour. Try again later.",
    AI_UNAVAILABLE: "Suggestions need the AI service, which isn't set up on this install.",
    AI_FAILED: "We couldn't get suggestions right now. Try again in a moment.",
};
//# sourceMappingURL=brand-suggestions.js.map